import { Route, Routes, Navigate } from "react-router-dom";
import LandingPage from "./Routes/LandingPage/LandingPage";
import CustomToolsLandingPage from "./Routes/LandingPage/CustomToolsLandingPage";
import Home from "./Routes/Home/Home";
import Login from "./Routes/Login/Login";
import Register from "./Routes/Register/Register";
import Quizzes from "./Routes/Quizzes/Quizzes";
import Quiz from "./Routes/Quiz/Quiz";
import Test from "./Routes/Test/Test";
import Report from "./Routes/Report/Report";
import Authenticated from "./Routes/Authenticated/Authenticated";
import Welcome from "./Routes/Welcome/Welcome";
import Pricing from "./Routes/Pricing/Pricing";
import Success from "./Routes/Payment/Success";
import ToolsPage from "./Routes/Tools/ToolsPage";
import AutomarkerPage from "./Routes/Tools/AutomarkerPage";
import ToolLandingPage from "./Routes/Tools/ToolLandingPage";
import PrivacyPolicy from "./Routes/PrivacyPolicy/PrivacyPolicy";
import TermsOfService from "./Routes/TermsOfService/TermsOfService";
import { useEffect } from "react";
import CreatePrompt from "./Routes/Prompts/CreatePrompt";
import UsePrompt from "./Routes/Prompts/UsePrompt";
import EditPrompt from "./Routes/Prompts/EditPrompt";
import PromptsList from "./Routes/Prompts/PromptsList";
import ToolsLandingPage from "./Routes/Tools/ToolsLandingPage";

// Public route component that redirects authenticated users
const PublicRoute = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    const isAuthenticated = !!localStorage.getItem("yippityUser");
    if (isAuthenticated) {
      window.location.href = "/home";
    }
  }, []);

  return <>{children}</>;
};

// Protected route component
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    setTimeout(() => {
      const isAuthenticated = !!localStorage.getItem("yippityUser");
      if (!isAuthenticated) {
        window.location.href = "/signin";
      }
    }, 2000);
  }, []);

  return <>{children}</>;
};

function App() {
  return (
    <Routes>
      {/* Public routes with authentication check */}
      <Route
        path="/"
        element={
          <PublicRoute>
            <LandingPage />
          </PublicRoute>
        }
      />
      <Route
        path="/custom-tools-landing"
        element={
          <PublicRoute>
            <CustomToolsLandingPage />
          </PublicRoute>
        }
      />
      <Route
        path="/signin"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/signup"
        element={
          <PublicRoute>
            <Register />
          </PublicRoute>
        }
      />
      <Route
        path="/landing-tools"
        element={
          <PublicRoute>
            <ToolsLandingPage />
          </PublicRoute>
        }
      />
      <Route
        path="/landing-tools/:slug"
        element={
          <PublicRoute>
            <ToolLandingPage />
          </PublicRoute>
        }
      />

      {/* Legal routes */}
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />

      {/* Authentication routes */}
      <Route path="/authenticated" element={<Authenticated />} />
      <Route path="/welcome" element={<Welcome />} />
      <Route path="/payment/success" element={<Success />} />

      {/* Protected routes */}
      <Route
        path="/pricing"
        element={
          <ProtectedRoute>
            <Pricing />
          </ProtectedRoute>
        }
      />
      <Route
        path="/home"
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />

      <Route
        path="/tools/:toolId"
        element={
          <ProtectedRoute>
            <ToolsPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/tools/automarker"
        element={
          <ProtectedRoute>
            <AutomarkerPage />
          </ProtectedRoute>
        }
      />

      {/* User Custom Tools Management - Updated Routes */}
      <Route
        path="/custom-tools"
        element={
          <ProtectedRoute>
            <PromptsList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/custom-tools/create"
        element={
          <ProtectedRoute>
            <CreatePrompt />
          </ProtectedRoute>
        }
      />
      <Route
        path="/custom-tools/:id"
        element={
          <ProtectedRoute>
            <UsePrompt />
          </ProtectedRoute>
        }
      />
      <Route
        path="/custom-tools/:id/edit"
        element={
          <ProtectedRoute>
            <EditPrompt />
          </ProtectedRoute>
        }
      />

      {/* Legacy quiz routes */}
      <Route
        path="/quiz"
        element={
          <ProtectedRoute>
            <Quizzes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/quiz/:quizId"
        element={
          <ProtectedRoute>
            <Quiz />
          </ProtectedRoute>
        }
      />
      <Route
        path="/quiz/:quizId/test"
        element={
          <ProtectedRoute>
            <Test />
          </ProtectedRoute>
        }
      />
      <Route
        path="/quiz/:quizId/report/:reportId"
        element={
          <ProtectedRoute>
            <Report />
          </ProtectedRoute>
        }
      />

      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
